export const TIER_SORT: Record<string, number> = {
   WHITE: 1,
   SILVER: 2,
   GOLD: 3,
   DIAMOND: 4,
};

export const TIER_SLUG_MAP: Record<string, string> = {
   WHITE: 'white',
   SILVER: 'silver',
   GOLD: 'gold',
   DIAMOND: 'diamond',
};

export const TIER_COLOR_MAP: Record<string, string> = {
   WHITE: '#C9CBE2',
   SILVER: '#868DC0',
   GOLD: '#FFDE98',
   DIAMOND: '#2498A0',
};

export const TIER_EXTRAS: Record<string, {
   dgeIncluded: boolean;
   dgeToggle?: boolean;
   dgePrice?: string;
   sweepstakesEntries: number;
   pylSpins: number;
   pylLabel: string;
   popular?: boolean;
   monthlyOnly?: boolean;
   checklist: string[];
}> = {
   WHITE: {
      dgeIncluded: false,
      dgeToggle: true,
      dgePrice: '+$9.99/mo',
      sweepstakesEntries: 25,
      pylSpins: 1,
      pylLabel: 'Extra spin in Press Your Luck each day',
      checklist: [
         'Profile badge and priority ranking on the social feed',
         'Access your Members-only chat',
         'Dedicated Membership Experience Coordinator',
      ],
   },
   SILVER: {
      dgeIncluded: true,
      sweepstakesEntries: 50,
      pylSpins: 2,
      pylLabel: 'Extra spins in Press Your Luck each day',
      popular: true,
      checklist: [
         'Profile badge and priority ranking on the social feed',
         'Access your Members-only chat',
         'Dedicated Membership Experience Coordinator',
      ],
   },
   GOLD: {
      dgeIncluded: true,
      sweepstakesEntries: 199,
      pylSpins: 3,
      pylLabel: 'Extra spins in Press Your Luck each day',
      checklist: [
         'Profile badge and priority ranking on the social feed',
         'Access your Members-only chat',
         'Dedicated Membership Experience Coordinator',
      ],
   },
   DIAMOND: {
      dgeIncluded: true,
      sweepstakesEntries: 1800,
      pylSpins: 5,
      pylLabel: 'Extra spins in Press Your Luck each day',
      monthlyOnly: true,
      checklist: [
         'Profile badge and priority ranking on the social feed',
         'Access your Members-only chat',
         'Dedicated Membership Experience Coordinator',
         'Direct access to the GolfN leadership team',
      ],
   },
};
